import { siteInfo, testimonials } from "@/mocks/articles";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useState } from "react";

export default function AboutPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    website_alt: "",
  });
  const [formStatus, setFormStatus] = useState<
    "idle" | "submitting" | "success" | "error"
  >("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    const payload = new FormData(form);
    const honeypot = (payload.get("website_alt") as string || "").trim();
    if (honeypot) {
      setFormStatus("success");
      setFormData({ name: "", email: "", message: "", website_alt: "" });
      setTimeout(() => setFormStatus("idle"), 3000);
      return;
    }
    payload.delete("website_alt");

    setFormStatus("submitting");
    setFormError("");

    try {
      const response = await fetch("https://readdy.ai/api/form/d9s91nee3oq4jqumu7ag", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === "OK") {
        setFormStatus("success");
        setFormData({ name: "", email: "", message: "", website_alt: "" });
      } else {
        const serverMsg =
          parsed?.meta?.message ||
          parsed?.message ||
          parsed?.meta?.detail ||
          responseText ||
          "提交失败，请稍后重试";
        setFormError(serverMsg);
        setFormStatus("error");
      }
    } catch {
      setFormError("网络错误，请检查你的网络连接后重试");
      setFormStatus("error");
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.name,
    description: siteInfo.description,
    url: "https://meinvgaoji.com",
    email: siteInfo.email,
    contactPoint: {
      "@type": "ContactPoint",
      email: siteInfo.email,
      contactType: "customer service",
      availableLanguage: "Chinese",
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-14">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", to: "/" },
                { label: "关于我们" },
              ]}
            />

            {/* Brand Intro */}
            <section className="mb-16">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
                关于 {siteInfo.name}
              </h1>
              <div className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8">
                <div className="flex flex-col md:flex-row gap-8 items-start">
                  <div className="flex-1">
                    <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                      我们的使命
                    </h2>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      美女搞基是一个专注于女性友谊与情感的内容平台。"美女搞基"这个词，指的是女生之间亲密无间的闺蜜情谊和姐妹情感——那种可以分享所有秘密、一起笑一起哭、在人生每个重要时刻都彼此陪伴的纯粹友情。
                    </p>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      在这个快节奏的时代，真正的友谊变得越来越珍贵。我们相信，每个女生都值得拥有能让她卸下所有盔甲、自由做自己的闺蜜。我们希望通过真实的故事、实用的建议和温暖的社区，帮助更多女生建立和维护深厚的姐妹情谊。
                    </p>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      无论是探讨闺蜜相处之道，还是分享姐妹间的成长故事，我们希望能成为你探索和珍惜女性友谊的一盏小灯。因为女生帮助女生，就是这个世界上最温柔也最有力量的事情。
                    </p>
                  </div>
                  <div className="w-full md:w-64 h-48 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Two%20Chinese%20women%20sitting%20on%20a%20rooftop%20at%20sunset%2C%20sharing%20intimate%20conversation%2C%20warm%20golden%20light%2C%20genuine%20friendship%20moment%2C%20soft%20blush%20and%20cream%20tones%2C%20artistic%20photography%20style&width=400&height=300&seq=about-brand-image&orientation=landscape"
                      alt="闺蜜情谊"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </section>

            {/* Brand Values */}
            <section className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">
                我们的价值观
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                {[
                  {
                    icon: "ri-heart-pulse-line",
                    title: "真实",
                    desc: "我们分享的是真实的女性故事和情感，不编造、不煽情、不贩卖焦虑。相信真实的共鸣才能带来真正的力量。",
                  },
                  {
                    icon: "ri-shield-star-line",
                    title: "尊重",
                    desc: "我们尊重每一种女性友谊的形态。无论你有一个闺蜜还是一群姐妹，无论你们的相处方式是热烈的还是安静的，都值得被看见。",
                  },
                  {
                    icon: "ri-sun-line",
                    title: "温暖",
                    desc: "我们希望这个平台像一个温暖的拥抱。当你感到孤独或困惑时，来这里看看，你会发现世界上有很多和你一样的女生。",
                  },
                ].map((value, idx) => (
                  <div
                    key={idx}
                    className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mx-auto mb-4">
                      <i className={`${value.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">
                      {value.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {value.desc}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            {/* Testimonials */}
            <section className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">
                读者口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {testimonials.map((t, idx) => (
                  <div
                    key={idx}
                    className="bg-background-100 border border-background-200/70 rounded-lg p-6"
                  >
                    <div className="flex items-center gap-1 text-accent-500 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      "{t.content}"
                    </p>
                    <div className="text-xs text-foreground-500">
                      <span className="font-medium text-foreground-800">
                        {t.name}
                      </span>
                      ，{t.age}岁，{t.city}
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact Form */}
            <section className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">
                联系我们
              </h2>
              <div className="flex flex-col lg:flex-row gap-10">
                <div className="flex-1">
                  <p className="text-sm text-foreground-600 mb-6">
                    如果你有任何关于闺蜜故事、合作或建议想要分享，欢迎随时联系我们。我们珍视每一条来自姐妹的声音。
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                        <i className="ri-mail-line"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">邮箱</p>
                        <p className="text-sm text-foreground-800">
                          {siteInfo.email}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <form
                    onSubmit={handleSubmit}
                    className="bg-background-100 border border-background-200/70 rounded-lg p-6 space-y-4"
                    data-readdy-form=""
                  >
                    <div>
                      <label
                        htmlFor="contact-name"
                        className="block text-sm font-medium text-foreground-800 mb-1"
                      >
                        你的名字
                      </label>
                      <input
                        id="contact-name"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                        placeholder="你的名字"
                        required
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="contact-email"
                        className="block text-sm font-medium text-foreground-800 mb-1"
                      >
                        邮箱地址
                      </label>
                      <input
                        id="contact-email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                        placeholder="your@email.com"
                        required
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="contact-message"
                        className="block text-sm font-medium text-foreground-800 mb-1"
                      >
                        留言内容
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        value={formData.message}
                        onChange={(e) =>
                          setFormData({ ...formData, message: e.target.value })
                        }
                        rows={4}
                        maxLength={500}
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 resize-none"
                        placeholder="写下你想说的话..."
                        required
                      ></textarea>
                      <p className="text-xs text-foreground-400 mt-1 text-right">
                        {formData.message.length}/500
                      </p>
                    </div>
                    <div className="honeypot-field">
                      <input
                        type="text"
                        name="website_alt"
                        value={formData.website_alt}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            website_alt: e.target.value,
                          })
                        }
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                    </div>
                    <button
                      type="submit"
                      disabled={formStatus === "submitting"}
                      className="w-full bg-primary-500 text-white py-3 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
                    >
                      {formStatus === "submitting" ? "发送中..." : "发送留言"}
                    </button>
                    {formStatus === "success" && (
                      <p className="text-sm text-accent-600 text-center font-medium">
                        留言发送成功！感谢你的联系，我们会尽快回复~
                      </p>
                    )}
                    {formStatus === "error" && formError && (
                      <p className="text-sm text-red-500 text-center">
                        {formError}
                      </p>
                    )}
                  </form>
                </div>
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}